
import { Component, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule, CompanyModule } from "@/store/modules/index";
import notifications from "../../../lib/notifications";
import mixin from "./mixin";
import { IOrderResource } from "@/store/types";
import * as modals from "@/lib/modals";

const orderModule = getModule(OrderModule);
const companyModule = getModule(CompanyModule);

@Component({ name: modals.consigneeContactSearchModal })
export default class ConsigneeContactSearchModal extends Mixins(mixin) {
  selectedContactId: string | number = null;
  isLoading: boolean = false;
  contacts: Array<any> = [];
  isSaving: boolean = false;

  get currentOrder(): IOrderResource {
    return orderModule.currentOrder;
  }
  get shipsWithOrders(): Array<{ number: number }> {
    return orderModule.currentOrderShipsWithOrders;
  }

  hasContacts() {
    return this.contacts.length > 0;
  }

  canSave() {
    return this.selectedContactId !== null;
  }

  add() {
    this.hideModal();
    orderModule.showAddConsigneeContactEntryModal();
  }

  async save() {
    this.isSaving = true;
    try {
        if (this.shipsWithOrders && this.shipsWithOrders.length > 0) {
          const confirmedAll = await this.$bvModal.msgBoxConfirm(
            `Do you want to add the consignee contact to all linked orders?`
          );
          if (confirmedAll) {
            this.shipsWithOrders.forEach(async (order) => {
            if(orderModule.currentOrder.headerNumber !== order.number) {
                  await orderModule.addConsigneeContact({
                    orderNumber: order.number,
                    contactId: this.selectedContactId
                  });
                }
            });
          } else {
            await orderModule.addConsigneeContact({
              orderNumber: this.currentOrder.number,
              contactId: this.selectedContactId
            });
          }
        }
        else {          
          await orderModule.addConsigneeContact({
            orderNumber: this.currentOrder.number,
            contactId: this.selectedContactId
          });
        }
      notifications.success("Order Contact Added", "Contact successfully added to order.");
      this.hideModal();
    } catch (ex) {
      notifications.error("Order Contact", "Failed to add contact to order. " + ex.data.message);
    }
    this.isSaving = false;
  }

  async load() {
    this.isLoading = true;

    try {
      let response = await companyModule.getCompanyContacts(this.currentOrder.contactCompanyId);
      this.contacts = response.data;
    } catch (ex) {
      notifications.error("Contacts", "Failed to load contacts. " + ex.data.message);
    }
    this.isLoading = false;
  }

  reset() {
    this.contacts = [];
    this.selectedContactId = null;
    this.isLoading = false;
  }

  select(contact) {
    if (contact.id === this.selectedContactId) this.selectedContactId = null;
    else this.selectedContactId = contact.id;
  }
}
